import { fontStyles, InlineExternalLink } from '@monash/portal-react';
import c from './info-header.module.scss';
import classNames from 'classnames';

const InfoHeader = ({ name, description, externalLink }) => {
  return (
    <div className={c.infoHeader}>
      <div className={classNames(fontStyles.heading, fontStyles.md)}>
        {name}
      </div>
      <div className={c.desc}>
        <div>{description}</div>
        <InlineExternalLink
          text={externalLink?.text}
          href={externalLink?.url}
        />
      </div>
    </div>
  );
};

export default InfoHeader;
